export const currencies = [
    {
        code: 'USD',
        cards: {
            visa: true,
            mastercard: true,
            'american-express': true,
            maestro: true,
            discover: true,
            'diners-club': true,
            jcb: true,
            elo: true,
            'union-pay': false,
            mir: false,
            hiper: false,
            hipercard: false,
            paypal: true,
        },
    },
    {
        code: 'EUR',
        cards: {
            visa: true,
            mastercard: true,
            'american-express': true,
            maestro: true,
            discover: true,
            'diners-club': true,
            jcb: true,
            elo: true,
            'union-pay': false,
            mir: false,
            hiper: false,
            hipercard: false,
            paypal: true,
        },
    },
    {
        code: 'CAD',
        cards: {
            visa: true,
            mastercard: true,
            'american-express': true,
            maestro: true,
            discover: false,
            'diners-club': false,
            jcb: true,
            elo: false,
            'union-pay': false,
            mir: false,
            hiper: false,
            hipercard: false,
            paypal: true,
        },
    },
    {
        code: 'AUD',
        cards: {
            visa: true,
            mastercard: true,
            'american-express': true,
            maestro: true,
            discover: false,
            'diners-club': false,
            jcb: true,
            elo: false,
            'union-pay': false,
            mir: false,
            hiper: false,
            hipercard: false,
            paypal: true,
        },
    },
    {
        code: 'GBP',
        cards: {
            visa: true,
            mastercard: true,
            'american-express': true,
            maestro: true,
            discover: true,
            'diners-club': true,
            jcb: true,
            elo: true,
            'union-pay': false,
            mir: false,
            hiper: false,
            hipercard: false,
            paypal: true,
        },
    },
    {
        code: 'NZD',
        cards: {
            visa: true,
            mastercard: true,
            'american-express': true,
            maestro: true,
            discover: false,
            'diners-club': false,
            jcb: true,
            elo: false,
            'union-pay': false,
            mir: false,
            hiper: false,
            hipercard: false,
            paypal: true,
        },
    },
    {
        code: 'SGD',
        cards: {
            visa: true,
            mastercard: true,
            'american-express': true,
            maestro: true,
            discover: false,
            'diners-club': false,
            jcb: true,
            elo: false,
            'union-pay': false,
            mir: false,
            hiper: false,
            hipercard: false,
            paypal: true,
        },
    },
    {
        code: 'MXN',
        cards: {
            visa: true,
            mastercard: true,
            'american-express': true,
            maestro: true,
            discover: false,
            'diners-club': false,
            jcb: false,
            elo: false,
            'union-pay': false,
            mir: false,
            hiper: false,
            hipercard: false,
            paypal: true,
        },
    },
    {
        code: 'BRL',
        cards: {
            visa: true,
            mastercard: true,
            'american-express': false,
            maestro: true,
            discover: false,
            'diners-club': false,
            jcb: true,
            elo: true,
            'union-pay': false,
            mir: false,
            hiper: false,
            hipercard: false,
            paypal: true,
        },
    }
];

export function getCardsSupportedByCurrency(currency) {
    const defaultCurrency = currencies.find((element) => element.code === 'USD').cards;

    try {
        let currencyCode = 'USD';

        if (currency) {
            currencyCode = currency.substring(0, 3);
        }

        let result = currencies.find((element) => element.code === currencyCode);

        if (result) {
            return result.cards;
        } else {
            throw new Error('Currency not found');
        }
    } catch (error) {
        console.error(error);
        return defaultCurrency;
    }
}
